import { createFileRoute } from '@tanstack/react-router'
import { PermissionRouteGuard } from '@/hooks/usePermissions'
import { AffiliationsPage } from '@/pages/Affiliations'

export const Route = createFileRoute('/_authenticated/affiliations')({
  component: AffiliationsGuard,
})

function AffiliationsGuard() {
  return (
    <PermissionRouteGuard resource="affiliations" action="read">
      <AffiliationsPage />
    </PermissionRouteGuard>
  )
}
